export const DND_ANIMATION_FIELD = 'animation-row';

const ANIMATION_TYPES = [
    {value: 'flyTo', label: I18n.t('fly_to')},
    {value: 'jumpTo', label: I18n.t('jump_to')},
    {value: 'rotateTo', label: I18n.t('rotate_to')},
    {value: 'easeTo', label: I18n.t('ease_to')},
]

export const DEFAULT_ANIMATION_DURATION = 100; //ms

export const ANIMATION_COMMON_PROPS = {
    center: {
        type: "coordinate",
        default: [0,0],
        description: I18n.t('mapbox_animation_center'),
        title: I18n.t('center')
    },
    zoom: {
        type: "number",
        default: 0,
        optional: true,
        description: I18n.t('mapbox_animation_zoom'),
        title: I18n.t('zoom_level')
    },
}

export const ANIMATION_PROPS = {
    type: {
        title: I18n.t("type"),
        description: I18n.t('mapbox_animation_type'),
        options: ANIMATION_TYPES,
        type: "enum",
        optional: false
    },
    animationName: {
        title: I18n.t("name"),
        description: I18n.t('mapbox_animation_name'),
        type: "string",
        optional: true
    },
    advancedSetting: {
        type: "json",
        description: I18n.t('mapbox_custom_settings'),
        title: I18n.t('advanced_settings')
    },
    flyTo: {
        duration: {
            type: "number",
            title: I18n.t('duration'),
            description: "The animation's duration, measured in milliseconds.",
            optional: true
        }
    },
    rotateTo: {
        bearing: {
            type: "number",
            description: "The compass direction that is 'up'; for example, a bearing of 90° orients the map so that east is up.",
            optional: false,
            title: I18n.t('bearing')
        },
        duration: {
            type: "number",
            title: I18n.t('duration'),
            description: "The animation's duration, measured in milliseconds.",
            optional: true
        },
        pitch: {
            description: "The desired pitch in degrees. The pitch is the angle towards the horizon measured in degrees with a range between 0 and 85 degrees. For example, pitch: 0 provides the appearance of looking straight down at the map, while pitch: 60 tilts the user's perspective towards the horizon. Increasing the pitch value is often used to display 3D objects.",
            title: I18n.t('pitch'),
            type: "number",
            default: 60,
            min: 0,
            max: 85
        }
    },
    easeTo: {
        duration: {
            type: "number",
            title: I18n.t('duration'),
            description: "The animation's duration, measured in milliseconds.",
            optional: true
        }
    },
    jumpTo: {
    }
}

export const animationMethods = {
    easeTo: (params, mapRef) => {mapRef.current.easeTo(params)},
    flyTo: (params, mapRef) => {mapRef.current.flyTo(params)},
    rotateTo: (params, mapRef) => {mapRef.current.rotateTo(params['bearing'] || 0,params)},
    jumpTo: (params, mapRef) => {mapRef.current.jumpTo(params)},
}